import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { LegendPrimitive, HiddenLegendPrimitive } from '../label-primitive/label-primitive.js';
import { legend } from './legend.css.js';

/** TODO */
const Legend = forwardRef((props, ref) => (jsx(LegendPrimitive, { "data-fpl-component": "", className: legend, ref: ref, ...props })));
Legend.displayName = 'Legend';
/** TODO */
const HiddenLegend = forwardRef((props, ref) => (jsx(HiddenLegendPrimitive, { ref: ref, ...props })));
HiddenLegend.displayName = 'HiddenLegend';

export { HiddenLegend, Legend };
//# sourceMappingURL=legend.js.map
